/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Block_SoonInputs */

const en_profile_block_soon = /** @type {(inputs: Profile_Block_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Block feature coming soon.`)
};

const es_profile_block_soon = /** @type {(inputs: Profile_Block_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Característica de bloqueo próximamente.`)
};

const fr_profile_block_soon = /** @type {(inputs: Profile_Block_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalité de blocage à venir.`)
};

const de_profile_block_soon = /** @type {(inputs: Profile_Block_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Blockierfunktion ist in Kürze verfügbar.`)
};

const id_profile_block_soon = /** @type {(inputs: Profile_Block_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitur blokir segera hadir.`)
};

/** @type {(inputs: Profile_Block_SoonInputs) => LocalizedString} */
const ja_profile_block_soon = en_profile_block_soon;

/** @type {(inputs: Profile_Block_SoonInputs) => LocalizedString} */
const zh_profile_block_soon = en_profile_block_soon;

/** @type {(inputs: Profile_Block_SoonInputs) => LocalizedString} */
const ar_profile_block_soon = en_profile_block_soon;

/** @type {(inputs: Profile_Block_SoonInputs) => LocalizedString} */
const it_profile_block_soon = en_profile_block_soon;

/** @type {(inputs: Profile_Block_SoonInputs) => LocalizedString} */
const ru_profile_block_soon = en_profile_block_soon;

/** @type {(inputs: Profile_Block_SoonInputs) => LocalizedString} */
const pt_profile_block_soon = en_profile_block_soon;

/** @type {(inputs: Profile_Block_SoonInputs) => LocalizedString} */
const ko_profile_block_soon = en_profile_block_soon;

/**
* | output |
* | --- |
* | "Block feature coming soon." |
*
* @param {Profile_Block_SoonInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const profile_block_soon = /** @type {((inputs?: Profile_Block_SoonInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Block_SoonInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_block_soon(inputs)
	if (locale === "es") return es_profile_block_soon(inputs)
	if (locale === "fr") return fr_profile_block_soon(inputs)
	if (locale === "de") return de_profile_block_soon(inputs)
	if (locale === "ja") return ja_profile_block_soon(inputs)
	if (locale === "zh") return zh_profile_block_soon(inputs)
	if (locale === "ar") return ar_profile_block_soon(inputs)
	if (locale === "id") return id_profile_block_soon(inputs)
	if (locale === "it") return it_profile_block_soon(inputs)
	if (locale === "ru") return ru_profile_block_soon(inputs)
	if (locale === "pt") return pt_profile_block_soon(inputs)
	return ko_profile_block_soon(inputs)
});